import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }

// import { NgModule } from '@angular/core';
// import { RouterModule, Routes } from '@angular/router';
// import { MaintenanceComponent } from './maintenance/maintenance.component';

// const routes: Routes = [

//   // Show maintenance page for root
//   {
//     path: '',
//     component: MaintenanceComponent
//   },

//   {
//     path: '**',
//     component: MaintenanceComponent
//   }

// ];

// @NgModule({
//   imports: [
//     RouterModule.forRoot(routes, {
//       onSameUrlNavigation: 'reload'
//     })
//   ],
//   exports: [RouterModule]
// })
// export class AppRoutingModule { }
